module.exports = __webpack_public_path__ + "img/regensburg_walhalla.8df295cd.jpg";